

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"17"}, rest), [h('path', {"fill":"#FFF","fill-rule":"nonzero","d":"M8.919 3.998A9.76 9.76 0 0 0 6.302 6L3 6a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-3.41l2-1.364V14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3l5.919-.002Zm3.677-3.26a.25.25 0 0 1 .147.048l7.069 5.106a.75.75 0 0 1 0 1.216l-7.07 5.106a.25.25 0 0 1-.396-.203l.001-2.993C10.167 9.137 7.375 9.92 5 13c0-4.822 3.166-8.612 7.346-8.972V.988a.25.25 0 0 1 .25-.25Z"}, [])]);
};

        